<template>
  <v-card flat>
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div>
        <span class="d-block text--secondary">{{ title }}</span>
        <span class="d-block font-weight-medium">{{ exchanges.length }}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn
        outlined
        small
        :loading="loading"
        @click="$emit('refresh')"
      >
        <v-icon
          size="18"
          class="me-2"
        >
          {{ icons.mdiRefresh }}
        </v-icon>
        <span>Обновить</span>
      </v-btn>
    </v-card-text>

    <v-card-text>
      <v-alert
        v-if="loaded && !exchanges.length"
        text
        color="info"
        class="mb-0"
      >
        {{ emptyHint }}
      </v-alert>

      <v-expansion-panels
        v-else-if="exchanges.length"
        accordion
        multiple
      >
        <v-expansion-panel
          v-for="exchange in exchanges"
          :key="exchange.id"
        >
          <v-expansion-panel-header>
            <div class="d-flex align-center flex-wrap">
              <v-chip
                small
                :color="statusColor(exchange)"
                :class="`${statusColor(exchange)}--text me-3`"
              >
                {{ exchange.statusCode || 'нет ответа' }}
              </v-chip>
              <v-chip
                v-if="exchange.source"
                small
                outlined
                class="me-3"
              >
                {{ exchange.source }}
              </v-chip>
              <span class="font-weight-medium me-3">{{ exchange.operation }}</span>
              <span class="text--secondary me-3">{{ exchange.method }}</span>
              <span class="text--secondary me-3">{{ formatDate(exchange.createdAt) }}</span>
              <span
                class="me-3"
                :class="exchange.durationMs >= slowMs ? 'error--text font-weight-medium' : 'text--secondary'"
              >
                {{ exchange.durationMs }} мс
              </span>
            </div>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <div class="mb-4">
              <span class="d-block text--secondary">Адрес</span>
              <code class="exchange-url">{{ exchange.url }}</code>
            </div>

            <v-alert
              v-if="exchange.error"
              text
              color="error"
              dense
            >
              Запрос не состоялся: {{ exchange.error }}
            </v-alert>

            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <span class="d-block text--secondary mb-1">Заголовки запроса</span>
                <pre class="exchange-block">{{ exchange.requestHeaders || '—' }}</pre>
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <span class="d-block text--secondary mb-1">Заголовки ответа</span>
                <pre class="exchange-block">{{ exchange.responseHeaders || '—' }}</pre>
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex align-center mb-1">
                  <span class="text--secondary">Тело запроса</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    x-small
                    text
                    @click="copy(exchange.requestBody)"
                  >
                    Скопировать
                  </v-btn>
                </div>
                <pre class="exchange-block">{{ pretty(exchange.requestBody) }}</pre>
              </v-col>

              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex align-center mb-1">
                  <span class="text--secondary">Тело ответа</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    x-small
                    text
                    @click="copy(exchange.responseBody)"
                  >
                    Скопировать
                  </v-btn>
                </div>
                <pre class="exchange-block">{{ pretty(exchange.responseBody) }}</pre>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiRefresh } from '@mdi/js'

export default {
  name: 'ExchangeLog',
  props: {
    exchanges: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    title: { type: String, required: true },
    emptyHint: { type: String, required: true },

    slowMs: { type: Number, default: 3000 },
  },
  data: () => ({
    icons: { mdiRefresh },
  }),
  methods: {
    statusColor(exchange) {
      if (!exchange.statusCode) return 'error'

      return exchange.isSuccess ? 'success' : 'error'
    },
    formatDate(value) {
      if (!value) return ''

      return new Date(value).toLocaleString('ru-RU')
    },

    pretty(body) {
      if (!body) return '—'

      try {
        return JSON.stringify(JSON.parse(body), null, 2)
      } catch {
        return body
      }
    },
    copy(body) {
      if (!body || !navigator.clipboard) return

      navigator.clipboard.writeText(body)
    },
  },
}
</script>

<style scoped>
.exchange-block {
  max-height: 320px;
  overflow: auto;
  padding: 8px;
  border-radius: 4px;
  background: rgba(127, 127, 127, 0.08);
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-word;
}

.exchange-url {
  word-break: break-all;
}
</style>
